import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CustomButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 47px;
  gap: 10px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #53a8a0;
  border-radius: 48px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.16px;
  color: #53a8a0;
  cursor: pointer;
`;

const CancelButton = (props) => {
  return <CustomButton>{props.children}</CustomButton>;
};

CancelButton.propTypes = {
  children: PropTypes.string.isRequired,
};

export default CancelButton;
